import { AppointmentBookingDto, AppointmentStatus } from '../../interfaces/appointments';

const isActive = (appointment: AppointmentBookingDto): boolean =>
  appointment.status === AppointmentStatus.Pending || appointment.status === AppointmentStatus.Confirmed;

/** Pending/confirmed bookings (hotel and manual alike) in one list, earliest first. */
export const buildPickList = (appointments: AppointmentBookingDto[]): AppointmentBookingDto[] =>
  appointments
    .filter(isActive)
    .sort((a, b) =>
      a.time.localeCompare(b.time) ||
      (a.vehicleLocation ?? '').localeCompare(b.vehicleLocation ?? '', 'nb', { numeric: true }));
